import { render, staticRenderFns } from "./CustomDateInput.vue?vue&type=template&id=88793e8e&scoped=true"
import script from "./CustomDateInput.vue?vue&type=script&lang=ts"
export * from "./CustomDateInput.vue?vue&type=script&lang=ts"
import style0 from "./CustomDateInput.vue?vue&type=style&index=0&id=88793e8e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88793e8e",
  null
  
)

export default component.exports